import React, { Component } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import AppLayout from '../index.jsx'
import Store from '../../../store';
import { useRouter } from 'next/router';
import { 
  getCountry, 
  getState, 
  handleFormStep,
  storeSavedData,
  setSavedData,
  handleSaveFormLoader,
  applicationSubmitted,
  handleFormLoader,
  saveStepSuccessForLoggedIn,
  saveStepSuccessForLoggedOut } from '../../../store/actions/application'

import { saveFormStep, saveBayanApplication } from '../../../api/application'
// import './style.scss'
import { toastr } from 'react-redux-toastr';

function FormAction(props){
  const router = useRouter();
  const dispatch = useDispatch();
  const { appId, loader, saveLoader, savedSteps, bayanStep, bayanProgress, loggedOutUserEmail } = useSelector((state) => ({
    appId: state.applicationReducer.appId,
    bayanStep: state.applicationReducer.bayanStep,
    loader: state.applicationReducer.loader,
    saveLoader: state.applicationReducer.saveLoader,
    savedSteps: state.applicationReducer.savedSteps,
    bayanProgress: state.applicationReducer.bayanProgress,
    loggedOutUserEmail: state.applicationReducer.loggedOutUserEmail
  }), shallowEqual);

  const { userAuth } = Store.getState();
  const userId = userAuth.userId;

  let { isFormDataValid, formStep, nextStep, formData, backStep } = props;
  let saveActive = savedSteps && Object.keys(savedSteps).length > 0

  function updateStep (step, next, save = false) {
    if (isFormDataValid && next) {
      dispatch(handleFormLoader(true))
      formData.hashed_id = savedSteps.id;
      formData.completed_step = formStep;
      formData.form_step = formStep;
      formData.next_step = nextStep;
      bayanProgress > formData.percent_completed ? formData.percent_completed = bayanProgress : null;
      if(loggedOutUserEmail && !userId){
        formData.email = loggedOutUserEmail;
      } else if (!loggedOutUserEmail && userId){
        formData.user_id = userId;
      }
      if(save) {
        formData.save_application = true;
      }
      saveFormStep(formData).then(res => {
        dispatch(handleFormLoader(false))
          if(res) {
            if(save){
              saveApp();
              return true;
            }
            if (!loggedOutUserEmail && userId){
              res.userId = userId;
              dispatch(saveStepSuccessForLoggedIn(res));
            } else {
              res.email = loggedOutUserEmail;
              dispatch(saveStepSuccessForLoggedOut(res));
            }     
            dispatch(handleFormStep(nextStep));
            dispatch(storeSavedData({data: formData, step: formData.form_step}));
          } 
      });
    }
    else if (!next) {
      dispatch(handleFormStep(step));
    }
  }

  function saveApp() {

    toastr.success('Thank You', 'Please check your email');
    router.push('/');
  }
    
    return(
      <div className={`action-btns-wrapper form-action ${formStep === 'reviewApp' ? 'review-btns-wrapper' : ''}`}>
        {
          !!backStep &&
          <div className="back-btn cursor-pointer" onClick={() => {updateStep(backStep, false)}}>
            <i className="fa fa-angle-left" aria-hidden="true"></i>
            back
          </div>
        }
        <div className="right-wrapper">
          <div className={`btn cursor-pointer save-btn ${(saveActive && isFormDataValid) ? '':'btn-disabled'}`} onClick={() => {updateStep(nextStep, true, true)}}>
            Save Application
          </div>
          {formStep !== 'reviewApp' &&
            <div className={`btn cursor-pointer active next-btn ${isFormDataValid ? '':'btn-disabled'}`} onClick={() => {updateStep(nextStep, true)}}>
            {
              formStep == 'applicationFee' ? 'Submit' : 'Next Step'
            }
            {loader && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />}
          </div>
          }
        </div>
      </div>
    );
  // }

}


export default FormAction;
